__webpack_require__.p = "/PokemonShinyGuide/";